module.exports = __webpack_public_path__ + "img/20240417081315073svg.328bc71e.jpg";